import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges, Sanitizer, SecurityContext } from '@angular/core';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProfilePageService } from '../services/profile-page.service';
import { Employee, Farm, FarmLocations, GetAllMessagesResponseType, GetReviewsResponseType, GetSubscribersResponseType, GetUsersResponseType, Message, Product } from '../../models/types';
import { LoginService } from '../services/login.service';
import { UserInfo } from '../../models/types';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { compareObjs } from '@fullcalendar/core/internal';
import { StatisticsService } from '../services/statistics.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo, faEnvelope, faTrash, faUser } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-farm-statistics-page',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule],
  templateUrl: './farm-statistics-page.component.html',
  styleUrl: './farm-statistics-page.component.scss'
})
export class FarmStatisticsPageComponent implements OnInit, OnChanges {

  @Input() farm: Farm | null = null;
  subscribers: GetSubscribersResponseType | undefined = undefined;
  allMessages: GetAllMessagesResponseType | undefined = undefined;
  allReviews: GetReviewsResponseType | undefined = undefined;

  faUser = faUser;
  faEnvelope = faEnvelope;
  faCircleInfo = faCircleInfo;
  faTrash = faTrash;

  weatherData: any;
  errorMessage: string = '';

  constructor(
    private profilePageService: ProfilePageService,
    private loginService: LoginService,
    private statisticsService: StatisticsService,
    private sanitizer: DomSanitizer        
  ) {}

  ngOnInit(): void {
    this.getWeather();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['farm'] && changes['farm'].currentValue) {
      console.log("Showing statistics for farm: ", this.farm);
    }
    this.getSubscribers();
    this.getAllMessages();
    this.getAllReviews();
  }

  getSubscribers(): void {
    if (this.farm) {
      this.statisticsService.getFarmSubscribers(this.farm.farmID).subscribe((response) => {
        this.subscribers = response;
        console.log("Subscribers: ", this.subscribers);
      });
    }
  }

  getAllMessages(): void {
    if (this.farm) {
      this.statisticsService.getAllMessages(this.farm.farmID).subscribe((response) => {
        this.allMessages = response;
        console.log("Messages: ", response);
      });
    }
  }

  getAllReviews(): void {
    if (this.farm) {
      this.statisticsService.getAllReviews(this.farm.farmID).subscribe((response) => {
        this.allReviews = response;
        console.log("Reviews: ", response);
      });
    }
  }

  openMessageDetails(message: Message): void {
    this.profilePageService.openMessageDetailsModal(message);
  }

  deleteMessage(message: Message): void {
    this.profilePageService.deleteMessage(message).subscribe(
      (response) => {
        console.log('Message deleted successfully:', response);
        this.getAllMessages();
      },
      (error) => {
        console.error('Error deleting message:', error);
        // Handle error
      }
    );
  }

  deleteSubscriber(subscriber: UserInfo): void {
    this.profilePageService.deleteSubscriber(subscriber.userID).subscribe(
      (response) => {
        console.log('Subscriber deleted successfully:', response);
        this.getSubscribers();
      },
      (error) => {
        console.error('Error deleting subscriber:', error);
        // Handle error
      }
    );
  }

  getSanitizedHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getWeather(): void {
    const lat = 46.051418;
    const lon = 14.505971;
    this.statisticsService.getWeather(lat, lon).subscribe({
      next: (data) => {
        this.weatherData = data;
        console.log('Weather data:', this.weatherData);
      },
      error: (err) => {
        this.errorMessage = 'Error fetching weather data';
        console.error('Error:', err);
      }
    });
  }

}
